import { createFileRoute } from "@tanstack/react-router";
import { kitsApprovalRoute } from "@/features/kits-approvals";

export const Route = createFileRoute("/kits/approvals/$approvalId")({
    ...kitsApprovalRoute,
});
